import ProvisionalReceipt from './ProvisionalReceipt';

export default ProvisionalReceipt;
